import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F9051 {
  f9051_01: string;        // 異動單號 (PK, auto-generated, readonly)
  f9051_02: string;        // 員工編號 (required, locked in edit mode)
  f9051_10: string | null; // 異動日期
  f9051_11: string;        // 原代理人1 (readonly)
  f9051_12: string;        // 原代理人2 (readonly)
  f9051_13: string;        // 原代理人3 (readonly)
  f9051_14: string;        // 原代理人4 (readonly)
  f9051_15: string;        // 原代理人5 (readonly)
  f9051_30: string;        // 異動說明 (textarea)
  f9051_31: string;        // 新代理人1
  f9051_32: string;        // 新代理人2
  f9051_33: string;        // 新代理人3
  f9051_34: string;        // 新代理人4
  f9051_35: string;        // 新代理人5
  f9051_36: string;        // 備註1
  f9051_37: string;        // 備註2
  f9051_38: string;        // 備註3
  f9051_39: string;        // 備註4
  f9051_40: string;        // 備註5
  f9051_91: string;        // 建立者
  f9051_92: string | null; // 建立日期
  f9051_93: string;        // 修改者
}

// ============================================================
// Request / Response types
// ============================================================

export interface PW9205ListResponse {
  data: F9051[];
  total: number;
  page: number;
  size: number;
}

export interface PW9205CreateRequest {
  master: Partial<F9051>;
}

// ============================================================
// API methods
// ============================================================

export const pw9205Api = {
  async list(page = 1, size = 20): Promise<PW9205ListResponse> {
    const res = await apiClient.get('/api/pw9205', { params: { page, size } });
    return res.data;
  },

  async search(keyword: string): Promise<PW9205ListResponse> {
    const res = await apiClient.get('/api/pw9205/search', { params: { keyword } });
    return res.data;
  },

  /** Single PK: doc number (f9051_01) */
  async get(docNo: string): Promise<F9051> {
    const res = await apiClient.get(`/api/pw9205/${encodeURIComponent(docNo)}`);
    return res.data;
  },

  async create(data: PW9205CreateRequest): Promise<F9051> {
    const res = await apiClient.post('/api/pw9205', data);
    return res.data;
  },

  /** Single PK: doc number (f9051_01) */
  async update(docNo: string, data: PW9205CreateRequest): Promise<F9051> {
    const res = await apiClient.put(`/api/pw9205/${encodeURIComponent(docNo)}`, data);
    return res.data;
  },

  /** Single PK: doc number (f9051_01) */
  async delete(docNo: string): Promise<void> {
    await apiClient.delete(`/api/pw9205/${encodeURIComponent(docNo)}`);
  },

  /** Lookup: employee name by type and code */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9205/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },

  /** Load current proxies from F905 for a given employee code */
  async getProxy(empCode: string): Promise<Partial<F9051>> {
    if (!empCode || !empCode.trim()) return {};
    try {
      const res = await apiClient.get(`/api/pw9205/proxy/${encodeURIComponent(empCode.trim())}`);
      return res.data || {};
    } catch {
      return {};
    }
  },
};
